import PropTypes from 'prop-types';
import './SettingsToggle.css';

/**
 * A toggle switch component for settings
 */
const SettingsToggle = ({ label, description, checked, onChange, disabled = false, icon, iconSrc }) => {
  const handleClick = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  const handleInputChange = (e) => {
    // Prevent double-toggle when clicking the input directly
    e.stopPropagation();
    onChange(e.target.checked);
  };

  return (
    <div 
      className={`settings-toggle-container ${disabled ? 'disabled' : ''} ${(icon || iconSrc) ? '' : 'no-icon'}`}
      onClick={handleClick}
      role="button"
      tabIndex={disabled ? -1 : 0}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && !disabled) {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      {iconSrc && (
        <div className="settings-toggle-icon">
          <img src={iconSrc} alt="" />
        </div>
      )}
      {!iconSrc && icon && (
        <div className="settings-toggle-icon">
          <i className={`fa ${icon}`} />
        </div>
      )}
      <div className="settings-toggle-text">
        <div className="settings-toggle-label">{label}</div>
        {description && <div className="settings-toggle-description">{description}</div>}
      </div>
      <label className="settings-toggle-switch" onClick={(e) => e.stopPropagation()}>
        <input
          type="checkbox"
          checked={checked}
          onChange={handleInputChange}
          disabled={disabled}
        />
        <span className="settings-toggle-slider"></span>
      </label>
    </div>
  );
};

SettingsToggle.propTypes = {
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  iconSrc: PropTypes.string,
};

export default SettingsToggle;
